export const LogOut = () => {
  localStorage.removeItem("isAuthenticated");
  window.location.reload();
};
